import { trustBadges } from '@/mocks/hoobuyData';

export default function TrustBadges() {
  return (
    <section className="w-full bg-background-50 py-8 md:py-10">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-3 px-4 py-3 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${badge.icon} text-base md:text-lg text-primary-600`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                {badge.textPt}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}